import { BaseButtonStyled } from '@procurify/ui'
import { rem } from 'polished'
import styled from 'styled-components'

export const ImporterPreviewStageStyled = styled.div`
  font-size: ${rem(16)};

  width: 100%;

  ${BaseButtonStyled}[disabled] {
    pointer-events: none;
  }

  .submit-btn-wrapper {
    display: inline-block;
    cursor: not-allowed;
    padding-left: 0.5em;
  }
`
